import { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { getAllDelivery } from "../../Service/DeliveryService";
import moment from 'moment';
import 'moment/locale/id';

const Delivery = () => {
    moment.locale('id');
    const navigate = useNavigate();

    const onAddData = () => {
        navigate("/delivery/create");
    }

    const onView = item => () => {
        // navigate("view/" + item.id);
    };

    const onEdit = item => () => {
        navigate("/delivery/edit/" + item.id);
    };

    const onRemove = item => () => {
        console.log('You click remove', item);
    };

    const columns = [
        { id: 1, title: 'Delivery No', field: 'docnumdel', sortable: true },
        { id: 2, title: 'Customer', field: 'u_m_card_nm', sortable: true },
        {
            id: 3,
            title: 'Order No',
            field: 'docnumso',
            sortable: true,
            render: data => <span>{data.docnumso || '-'}</span>
        },
        { id: 4, title: 'Type', field: 'delivery_type', sortable: true },
        { id: 5, title: 'Created Date', field: 'created_date', sortable: true, filter_text: "Please type in this format: 'YYYY-MM-DD HH.MM.SS', example: 2023-03-01 06.30.23. You can also exclude the hour, minute, seconds, date, month or year. Example : 2023-03, 2023-04-01 16.04",
            render: data => {
                moment.locale('id');
                return moment(data.created_date).format('ll LTS')
            }
        },
        {
            id: 6,
            title: 'Status',
            field: 'status',
            sortable: true,
            render: data => {
                var text = "";
                if (data.status == 'Cancel') {
                    text = <span className="badge bg-red me-2">Cancel</span>;
                } else if (data.status == 'Paid') {
                    text = <span className="badge bg-paid me-2">Paid</span>;
                } else if (data.status == 'Close') {
                    text = <span className="badge bg-close me-2">Close</span>;
                } else if (data.status == 'Open') {
                    text = <span className="badge bg-cyan me-2">Open</span>;
                }
                return text;
            },
        },
        {
            id: 7,
            title: 'Action',
            render: item => {
                return (
                    <div style={{width:90}}>
                        <a
                            onClick={onEdit(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-edit" />
                            <span style={{ marginLeft: 10 }}>Edit</span>
                        </a>
                        
                    </div>
                );
            },
        },
    ];


    const propsTable = { columns, getData: getAllDelivery, showIndex: true, showAddButton: true, onAddData, order: 'docnumdel', direction: 'desc' };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Delivery List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <div className='table-responsive'>
                                <MTable {...propsTable} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default Delivery;